import React from 'react'
import { Link } from 'react-router-dom'
import appRoutes from '../../routes/routeConfig'

const PasswordReset = () => {
    return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <a href="index.html" className="logo logo-admin">
                                                <img src="assets/images/logo-sm.png" height="50" alt="logo" className="auth-logo" />
                                            </a>
                                            <h4 className="mt-3 mb-1 font-weight-semibold text-white font-18">Reset Password</h4>   
                                            <p className="text-white mb-0">Reset instructions will be sent to your email!</p>  
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        <form className="form-horizontal auth-form my-4" action="index.html">
            
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label for="username">New Password</label>
                                                    <div className="input-group mb-3">
                                                        <input type="password" className="form-control"  id="email" placeholder="Enter new password" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                            <div className="form-group">
                                                <label for="username">Confirm Password</label>
                                                <div className="input-group mb-3">
                                                    <input type="password" className="form-control"  placeholder="COnfirm Password" />
                                                </div>
                                            </div>
                                            </div>
                                        </div>

                                            <div className="form-group mb-0 row">
                                                <div className="col-12 mt-2">
                                                    <Link to={appRoutes.login.root}>
                                                        <button className="btn btn-primary btn-block waves-effect waves-light" type="button">Reset <i className="fas fa-sign-in-alt ml-1"></i></button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form> 
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; 2022</span>                                           
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordReset